import { useCallback, useState } from "react"
import CadastroInput from "../../models/CadastroInput"
import http from "../../../../http"

export const useAtualizaCadastro = () => {
    const [resposta, setResposta] = useState({})

    const atualizarCadastro = useCallback((cadastro_id, inputsCadastro) => {
        let cadastro
        try {
            cadastro = CadastroInput.create({
                ...inputsCadastro,
                id: cadastro_id,
            })
        } catch (error) {
            setResposta({ data: null, error: { data: error.message } })
            return
        }

        http.put(`/cadastros/${cadastro_id}`, cadastro)
            .then(res => {
                if(res.status === 204) setResposta({ data: 'Cadastro foi atualizado com sucesso', error: null })
            })
            .catch(error => {
                const { response } = error 
                setResposta({ data: null, error: response })
            })
    }, [])

    return [resposta, atualizarCadastro]
}
